module.exports = new __parcel__URL__("demongrasp.9ce61dd8.png").toString();